import { searchParam } from '@luminovo/design-system';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod/v4';

import QuoteRequestEmailPreviewPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestEmailPreviewPage';
import { quoteRequestsBelongTo } from '@/domain/quoteRequest/quoteRequestHandler';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The email names the project, and the page shows the quote requests in the project's sidebar. Quote requests of
// another project or of a negotiation, which only a hand-edited URL brings, render the not-found page rather than send
// their suppliers an email with this project's name.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: z.object({ quoteRequestIds: searchParam.list('required') }),
    loaderDeps: ({ search }) => ({ quoteRequestIds: search.quoteRequestIds }),
    loader: async ({ context: { queryClient }, params: { projectId }, deps: { quoteRequestIds } }) => {
        if (!(await quoteRequestsBelongTo(queryClient, quoteRequestIds, { type: 'Rfq', id: projectId }))) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const quoteRequestIds = Route.useSearch({ select: (search) => search.quoteRequestIds });
    return <QuoteRequestEmailPreviewPage {...pathParams} quoteRequestIds={quoteRequestIds} />;
}
